import React from "react";
import SignComponent from "../../../components/signComponent";
import { Grid } from "@mui/material";

const SignatureCard = ({ title, signature, name, position, children }) => (
  <div className="approval-status-box approved">
    <div className="column-center">
      <p>{title}</p>
      {children ||
        (signature && (
          <img
            src={signature}
            alt={`Firma ${title.toLowerCase()}`}
            style={{
              width: "100%",
              maxWidth: "450px",
              height: "160px",
              objectFit: "contain",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D1D5DB",
              borderRadius: "4px"
            }}
          />
        ))}
      {name && <p className="approver-text">{name}</p>}
      {position && <p className="approver-text">{position}</p>}
    </div>
  </div>
);

const ElectronicSignature = ({
  setSignature,
  base64Signature,
  elaboratorName,
  elaboratorPosition,
  approverSignature,
  approverName,
  approverPosition,
  approvalText,
  isApprover,
  isViewer,
  isLocked
}) => {
  const hasApproverSignature = Boolean(approverSignature);
  const showElaboratorSignatureImage = Boolean(
    base64Signature && (isViewer || isLocked)
  );

  return (
    <Grid
      container
      justifyContent="center"
      spacing={2}
      className="technical-inspection-signatures"
    >
      <Grid item xs={12} md={6}>
        <p className="createRist-title mt-25">5. Firma electronica</p>
        <SignatureCard
          title="Elaborado"
          signature={showElaboratorSignatureImage ? base64Signature : null}
          name={elaboratorName}
          position={elaboratorPosition}
        >
          {!showElaboratorSignatureImage && (
            <SignComponent
              setSignature={setSignature}
              base64Signature={base64Signature}
              isApprover={isApprover}
              isViewer={isViewer || isLocked}
            />
          )}
        </SignatureCard>
      </Grid>
      <Grid item xs={12} md={6}>
        <p className="createRist-title mt-25">6. Aprobacion</p>
        {hasApproverSignature ? (
          <SignatureCard
            title={approvalText}
            signature={approverSignature}
            name={approverName}
            position={approverPosition}
          />
        ) : (
          <div className="approval-status-box">
            <div className="column-center">
              <p>{approvalText}</p>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default ElectronicSignature;
